import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface TimezoneContextType {
  useFranceTime: boolean;
  setUseFranceTime: (value: boolean) => void;
  formatInTimezone: (date: Date) => Date;
}

const TimezoneContext = createContext<TimezoneContextType | undefined>(undefined);

export function TimezoneProvider({ children }: { children: ReactNode }) {
  const [useFranceTime, setUseFranceTime] = useState(() => {
    const stored = localStorage.getItem('useFranceTime');
    // Default to true (France time) if not set
    return stored === null ? true : stored === 'true';
  });

  useEffect(() => {
    localStorage.setItem('useFranceTime', String(useFranceTime));
  }, [useFranceTime]);

  // Convert a Date to the selected timezone for display
  const formatInTimezone = (date: Date): Date => {
    if (useFranceTime) {
      return new Date(date.toLocaleString('en-US', { timeZone: 'Europe/Paris' }));
    }
    return date;
  };

  return (
    <TimezoneContext.Provider value={{ useFranceTime, setUseFranceTime, formatInTimezone }}>
      {children}
    </TimezoneContext.Provider>
  );
}

export function useTimezone() {
  const context = useContext(TimezoneContext);
  if (context === undefined) {
    throw new Error('useTimezone must be used within a TimezoneProvider');
  }
  return context;
}
